import { render } from "./GlossaryView.vue?vue&type=template&id=0dc45624"
import script from "./GlossaryView.vue?vue&type=script&lang=js"
export * from "./GlossaryView.vue?vue&type=script&lang=js"

import "./GlossaryView.vue?vue&type=style&index=0&id=0dc45624&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__